var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{class:`pa-0 font-weight-bold text-sm-left ${_vm.smallMargin? 'mb-0' : 'mb-8'}`},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }